import type { SVGProps } from 'react'
const LineRefreshCcw = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M12 3a8.98 8.98 0 0 0-7.5 4.03V3H3v5.75C3 9.44 3.56 10 4.25 10H10V8.5H5.365c1.29-2.45 3.83-4 6.635-4 4.135 0 7.5 3.365 7.5 7.5s-3.365 7.5-7.5 7.5a7.51 7.51 0 0 1-7.245-5.56l-1.45.39A9.01 9.01 0 0 0 12 21c4.96 0 9-4.04 9-9s-4.04-9-9-9"
		/>
	</svg>
)
export { LineRefreshCcw }
